import { clamp, easeOutCubic, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createOrigin(): DrawFn {
  const rng = mulberry32(1)
  const sparks = Array.from({ length: 24 }, () => ({
    a: -1.2 + rng() * 2.4,
    speed: 20 + rng() * 50,
    delay: 0.2 + rng() * 0.4,
    life: 0.6 + rng() * 0.7,
    s: 0.6 + rng() * 1.4,
  }))

  return (ctx, t, w, h) => {
    const cx = w * 0.5
    const cy = h * 0.4
    ctx.clearRect(0, 0, w, h)
    const flame = easeOutCubic(clamp((t - 0.15) / 0.8))
    const flicker = 0.9 + Math.sin(t * 11) * 0.1

    ctx.globalCompositeOperation = 'lighter'
    glow(ctx, cx, cy, 80 * flame * flicker, 'rgba(255,140,40,0.22)')
    glow(ctx, cx, cy - 10, 18 * flame * flicker, 'rgba(255,230,160,0.7)')

    for (const s of sparks) {
      const age = t - s.delay
      if (age < 0 || age > s.life) continue
      const u = age / s.life
      const x = cx + Math.cos(s.a) * age * s.speed * 0.4
      const y = cy - age * s.speed
      ctx.fillStyle = `rgba(255,180,60,${(1 - u) * 0.8})`
      ctx.beginPath()
      ctx.arc(x, y, s.s * (1 - u), 0, TAU)
      ctx.fill()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
